import { Injectable } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { NoteService } from '../../services/note/note.service';
import { DataService } from '../../services/data/data.service';
import _ from 'lodash';

@Injectable()

export class SettingsService {

	countryCodes;
	divisionCodes;
	userConfigs = {};

	constructor(
		private commsService: CommsService,
		private configService: ConfigService,
		private displayService: DisplayService,
		private noteService: NoteService,
		private dataService: DataService,
	) { }

	parseUserNotificationConfigs() {
		this.dataService.userSettings.notificationConfigs = [];

		// group configs by category
		const self = this;
		const configsByCat = _.groupBy(this.userConfigs['config'], 'category');
		Object.keys(configsByCat).forEach(categoryKey => {
			// for each category, need group by description
			const configsByDesc = _.groupBy(configsByCat[categoryKey], 'description');
			const configsArray = [];
			Object.keys(configsByDesc).forEach(descriptionKey => {
				const configJson = {description: descriptionKey};
				configsByDesc[descriptionKey].forEach(config => {
					configJson[config.type] = {id: config.id, subscribed: config.subscribed};
				});
				configsArray.push(configJson);
			});
			self.dataService.userSettings.notificationConfigs.push({category: categoryKey, configs: configsArray});
		});
		console.log('USER SETTINGS PARSED:', self.dataService.userSettings);
	}

	parseUserCodes() {
		let countryFilters = [];
		let divisionFilters = [];
		let costCenterFilters = [];

		const self = this;
		try {
			if (this.userConfigs['countryconfigs'] !== undefined) {
				countryFilters = this.userConfigs['countryconfigs'];
				countryFilters.forEach(filter => {
					if (!filter.countrycode) {
						filter.countrycode = this.dataService.emptyLabel;
					}
				});
			}
			if (this.userConfigs['divisionconfigs'] !== undefined) {
				divisionFilters = this.userConfigs['divisionconfigs'];
				divisionFilters.forEach(filter => {
					if (!filter.divisioncode) {
						filter.divisioncode = this.dataService.emptyLabel;
					}
				});
			}
			if (this.userConfigs['costcenterconfigs'] !== undefined) {
				costCenterFilters = this.userConfigs['costcenterconfigs'];
				costCenterFilters.forEach(filter => {
					if (!filter.costcenter) {
						filter.costcenter = this.dataService.emptyLabel;
					}
				});
			}
		} catch (e) {
			self.noteService.displayError('User settings for country, division, & cost center codes are in the wrong format.');
		}

		this.dataService.updateUserCodes(countryFilters, divisionFilters, costCenterFilters);
		console.log('USER CODES PARSED:', countryFilters, divisionFilters, costCenterFilters);
	}

	submitConfigs(configs) {
		const configsArr = [];
		configs.notificationConfigs.forEach(configObj => {
			configObj.configs.forEach(config => {
				if (config.email) {
					configsArr.push(config.email);
				}
				if (config.system) {
					configsArr.push(config.system);
				}
			});
		});
		configs.divisionFilters.forEach(filter => {
			if (filter.divisioncode === this.dataService.emptyLabel) {
				filter.divisioncode = '';
			}
		});
		configs.countryFilters.forEach(filter => {
			if (filter.countrycode === this.dataService.emptyLabel) {
				filter.countrycode = '';
			}
		});
		configs.costCenterFilters.forEach(filter => {
			if (filter.costcenter === this.dataService.emptyLabel) {
				filter.costcenter = '';
			}
		});
		const data = {
			configs: configsArr,
			divisionconfigs: configs.divisionFilters,
			countryconfigs: configs.countryFilters,
			costcenterconfigs: configs.costCenterFilters
		};

		const self = this;
		this.commsService.postUserConfigs(data).subscribe((res) => {
			console.log('Update User Configs: ', res);
			self.noteService.displaySuccess('The user configurations have been updated successfully.');
			self.displayService.endLoading();
			const delay = setTimeout(function(){
				self.loadUserSettings();
			}, 1000);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Update User Configs', err);
		});
	}

	resetConfigs() {
		this.loadUserSettings();
	}

	loadUserSettings() {
		const self = this;
		this.displayService.startLoading();
		this.commsService.getUserConfigs().subscribe((res) => {
			console.log('LOAD USER CONFIGs: ', res);
			const successData = self.commsService.getSuccessData(res);
			try {
				self.userConfigs = successData;
				self.parseUserNotificationConfigs();
				self.parseUserCodes();
			} catch (e) {
				self.noteService.displayError('The user configurations have been retrived from the server successfully, but the format is not correct.');
			} finally {
				self.displayService.endLoading();
			}
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Load User Configs', err);
		});
	}

	loadAllCountryCodes() {
		const self = this;
		this.displayService.startLoading();
		this.commsService.getCountryCodes().subscribe((res) => {
			console.log('LOAD ALL COUNTRY CODES: ', res);
			const successData = self.commsService.getSuccessData(res);

			try {
				const codes = [];
				successData.forEach(code => {
					codes.push(code.countrycode);
				});
				codes.push('');
				self.dataService.updateCountryCodes(codes);
			} catch (e) {
				self.noteService.displayError('Country codes have been retrived from the server successfully, but the format is not correct.');
			} finally {
				self.displayService.endLoading();
			}
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Load All Country Codes', err);
		});
	}

	loadAllDivisionCodes() {
		const self = this;
		this.displayService.startLoading();
		this.commsService.getDivisionCodes().subscribe((res) => {
			console.log('LOAD ALL DIVISION CODES: ', res);
			const successData = self.commsService.getSuccessData(res);
			try {
				const codes = [];
				successData.forEach(code => {
					codes.push(code.divisioncode);
				});
				codes.push('');
				self.dataService.updateDivisionCodes(codes);
			} catch (e) {
				self.noteService.displayError('Division codes have been retrived from the server successfully, but the format is not correct.');
			} finally {
				self.displayService.endLoading();
			}
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Load All Division Codes', err);
		});
	}

	loadAllCostCenters() {
		// cost centers are already kept up to date in user configs, parse the list from there
		// and copy to data service just as a flat list
		if (this.userConfigs['costcenterconfigs'] !== undefined) {
			this.dataService.updateCostCenters(this.userConfigs['costcenterconfigs'].map(x => {
					return x.costcenter;
				}));
		}
	}

}
